import { render, staticRenderFns } from "./collectModal.vue?vue&type=template&id=1b495b09&scoped=true"
import script from "./collectModal.vue?vue&type=script&lang=js"
export * from "./collectModal.vue?vue&type=script&lang=js"
import style0 from "./collectModal.vue?vue&type=style&index=0&id=1b495b09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b495b09",
  null
  
)

export default component.exports